import cloneDeep from "clone-deep";
import { useCallback, useMemo } from "react";
import { usePanelAccommodationContext } from "../context.js";
const usePanelAccommodation = (maxPeople)=>{
    const { rooms , onChange  } = usePanelAccommodationContext();
    const deleteRoom = useCallback((roomIndex)=>()=>{
            const newRooms = cloneDeep(rooms);
            newRooms.splice(roomIndex, 1);
            onChange(newRooms);
        }, [
        rooms,
        onChange
    ]);
    const totalPeople = useMemo(()=>rooms.flatMap((room)=>room.people).reduce((acc, person)=>acc + person.value, 0), [
        rooms
    ]);
    const disableIncrement = !!maxPeople && maxPeople <= totalPeople;
    return {
        disableIncrement,
        rooms,
        deleteRoom
    };
};
export default usePanelAccommodation;

//# sourceMappingURL=usePanelAccomodation.js.map